import { render, staticRenderFns } from "./logoutCallback.vue?vue&type=template&id=726a8cc8"
import script from "./logoutCallback.vue?vue&type=script&lang=ts"
export * from "./logoutCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports